<template>
  <div>
    <h5 class="edume-completed-all-content-heading">
      {{ heading }}
    </h5>
    <p class="edume-completed-all-content-message">
      {{ message }}
    </p>
  </div>
</template>

<script>
import {polyglot} from '../utils/polyglot';

export default {
  props: {
    numItems: {
      type: Number,
      required: true,
    },
  },
  data() {
    const {numItems} = this;
    let message = '';
    if (numItems === 1) {
      message = polyglot.t('Completed.message.singular', {
        numItems,
      });
    } else if (numItems > 1) {
      message = polyglot.t('Completed.message.plural', {
        numItems,
      });
    } else {
      message = polyglot.t('Completed.message.revisit');
    }
    return {
      isOpen: false,
      heading: polyglot.t('Completed.heading'),
      message,
    };
  },
};
</script>

<style>
.edume-completed-all-content-heading {
  margin: 0px 0px 6px;
  color: #5e5f61;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
}
.edume-completed-all-content-message {
  color: #5e5f61;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}
</style>
